export const green = '#04D9D9';
export const silver = '#c1c1c1';
export const brown = '#483737';

export const font = '16px helvetica, arial, sans-serif';
export const largeFont = 'bold 24px helvetica, arial, sans-serif';
export const smallFont = '14px helvetica, arial, sans-serif';

export const colours = {
  green,
  silver,
  brown,
};

export const shadows = {
  top: '0px -2px 10px rgba(0, 0, 0, 0.2)',
  bottom: '0px 2px 10px rgba(0, 0, 0, 0.2)',
};

export const radius = '4px';

const styles = {
  colours,
  shadows,
  radius,
};

export default styles;



/** WEBPACK FOOTER **
 ** ./src/Styles.js
 **/